export const common = {
  // Header
  'header.home': 'ホーム',
  'header.purchase': '購入',
  'header.about': '会社概要',
  'header.messages': 'メッセージ',
  'header.contact': 'お問い合わせ',
  
  // Hero Section
  'hero.title': 'DP CryptでUSDTを即座に購入',
  'hero.description': '高速、安全、信頼性の高いUSDT取引プラットフォーム。最高のレートで即時取引と24時間365日のサポートを提供します。',
  'hero.cta.buy': '今すぐUSDTを購入',
  'hero.trust.secure': '安全でライセンス取得済み',
  'hero.trust.instant': '即時処理',
  'hero.trust.support': '24時間365日サポート',
  
  // Trading Widget
  'trading.title': 'USDTを購入',
  'trading.youSpend': '支払い金額',
  'trading.youReceive': '受取金額',
  'trading.rate': '為替レート',
  'trading.fee': '処理手数料',
  'trading.button': '今すぐUSDTを購入',
  'trading.rateUpdate': 'リアルタイムレートは30秒ごとに更新されます',
  
  // Features Section
  'features.title': 'DP Cryptを選ぶ理由',
  'features.subtitle': '最も安全で、高速、そしてユーザーフレンドリーな暗号資産取引プラットフォームを体験してください',
  'features.instant.title': '即時取引',
  'features.instant.desc': '入金確認後、5営業日以内に送金します。',
  'features.seamless.title': 'シームレスな体験',
  'features.seamless.desc': '支払い承認まで簡単に進める使いやすいダッシュボード。暗号資産初心者に最適です！',
  'features.peace.title': '安心感',
  'features.peace.desc': 'DP Cryptは完全にライセンスを取得し、規制されているため、安全に暗号資産の世界に参入できます。',
  'features.payment.title': 'シンプルな支払い方法',
  'features.payment.desc': '様々な簡単な支払い方法を提供しています。',
  'features.fraud.title': '不正防止',
  'features.fraud.desc': 'DP Cryptは、ユーザーを保護し、不正を特定、防止、損失に対する保険を提供する高度なツールを活用しています。',
  'features.support.title': '24時間365日サポート',
  'features.support.desc': '誰もが時々助けを必要とします。DP Cryptでは、優れたカスタマーケアチームが24時間体制でサポートいたします。',
  'features.rates.title': '最高の為替レート',
  'features.rates.desc': '透明性のある価格設定で競争力のあるレート',
  'features.payment.title': '複数の支払い方法',
  'features.payment.desc': 'USD、EUR、JPY、GBP、CADに対応',
  'features.kyc.title': 'シンプルなKYCプロセス',
  'features.kyc.desc': '迅速な認証で素早く開始できます',
  
  // How It Works
  'howItWorks.title': 'USDTを即座に購入する方法',
  'howItWorks.step1.title': '受取ウォレットはお持ちですか？',
  'howItWorks.step1.desc': 'USDTを受け取るウォレットはお持ちですか？TRC20 USDTウォレットをご用意ください。',
  'howItWorks.step2.title': '暗号資産の価格を確認',
  'howItWorks.step2.desc': 'USDTやその他の暗号資産のリアルタイム価格を確認し、購入したい金額を選択します。お好みの支払いオプションを選択し、支払い詳細を完了してください。',
  'howItWorks.step3.title': 'USDTを受け取る',
  'howItWorks.step3.desc': '取引が送信されると、支払い承認後30分以内にウォレットに暗号資産を送信します。とても簡単です！',
  'howItWorks.cta': '暗号資産を購入',
  
  // Trust Section
  'trust.title': '2025年以来、世界中で信頼されています',
  'trust.subtitle': '当社のサービスは世界中の10,000人以上の満足した顧客に信頼されています',
  'trust.testimonial1.name': 'サラ・ジョンソン',
  'trust.testimonial1.role': '暗号資産投資家',
  'trust.testimonial1.content': 'DP Cryptのおかげで、初めてのビットコイン購入が信じられないほど簡単でした。プロセスはスムーズで、15分以内に暗号資産を受け取りました！',
  'trust.testimonial2.name': 'マイケル・チェン',
  'trust.testimonial2.role': 'デイトレーダー',
  'trust.testimonial2.content': 'プラットフォームは信頼性が高く安全です。半年以上DP Cryptを使用していますが、取引で問題が発生したことはありません。',
  'trust.testimonial3.name': 'エマ・ロドリゲス',
  'trust.testimonial3.role': 'ビジネスオーナー',
  'trust.testimonial3.content': '優れたカスタマーサポートと競争力のあるレート。DP Cryptは私のすべての暗号資産購入のための頼りになるプラットフォームです。',
  'trust.badge.licensed': 'ライセンス取得・規制済み',
  'trust.badge.security': '銀行レベルのセキュリティ',
  'trust.badge.support': '24時間365日サポート',
  'trust.transactions': '総取引数',
  'trust.users': 'アクティブユーザー',
  'trust.countries': 'サービス提供国',
  'trust.uptime': '稼働率',
  
  // Footer
  'footer.buyCrypto': '暗号資産を購入',
  'footer.products': '製品',
  'footer.auroraCard': 'Aurora Card',
  'footer.support': 'サポート',
  'footer.contact': 'お問い合わせ',
  'footer.about': '会社概要',
  'footer.privacy': 'プライバシーポリシー',
  'footer.rights': 'All rights reserved.',
  'footer.description': 'USDTを即座に購入。高速、安全、そして世界中の何千人もの人々に信頼されています。',
  
  // Aurora Card
  'aurora.hero.title': 'Aurora Card（オーロラカード）',
  'aurora.hero.subtitle': '暗号資産をそのまま使える革新的なクレジットカード',
  'aurora.hero.description': '複数の暗号資産を保管し、世界210ヵ国の8,000万以上の加盟店で決済可能。面倒な現金化手続きは不要です。',
  'aurora.hero.cta.signup': '今すぐ登録する',
  'aurora.hero.cta.website': '公式サイトを見る',
  
  'aurora.overview.title': 'Aurora Cardとは？',
  'aurora.overview.subtitle': '暗号資産を現金化せずに、そのまま決済に使える次世代のクレジットカード',
  'aurora.overview.feature1.title': '複数の暗号資産に対応',
  'aurora.overview.feature1.desc': 'ビットコイン、イーサリアム、USDT など、複数の暗号資産を一つのカードで管理。公式アプリから簡単に入金できます。',
  'aurora.overview.feature2.title': '世界中で使える',
  'aurora.overview.feature2.desc': '世界210ヵ国、8,000万以上のMastercard加盟店で利用可能。日本国内でも問題なく使えます。',
  'aurora.overview.feature3.title': '面倒な手続き不要',
  'aurora.overview.feature3.desc': '従来の「ウォレット→取引所→銀行口座」という複雑な現金化プロセスが不要。アプリに入金するだけで即座に決済可能。',
  'aurora.overview.feature4.title': '高いセキュリティ',
  'aurora.overview.feature4.desc': '信託機関と連携し、顧客資産は法的に保護。第三者による口座情報へのアクセスを完全にブロックします。',
  'aurora.overview.recommended.title': 'こんな方におすすめ',
  'aurora.overview.recommended.item1': '暗号通貨を現金化することが面倒な方',
  'aurora.overview.recommended.item2': '手軽に暗号通貨を使いたい方',
  'aurora.overview.recommended.item3': '安全性・信頼性が高いカードを保有したい方',
  
  'aurora.comparison.title': '従来のクレジットカードとの違い',
  'aurora.comparison.subtitle': 'Aurora Cardなら、暗号資産の現金化が不要',
  'aurora.comparison.traditional.title': '従来の方法',
  'aurora.comparison.traditional.step1': 'ウォレットから取引所へ送金',
  'aurora.comparison.traditional.step1.fee': '送金手数料が発生',
  'aurora.comparison.traditional.step2': '取引所で暗号資産を現金化',
  'aurora.comparison.traditional.step2.fee': '取引手数料が発生',
  'aurora.comparison.traditional.step3': '銀行口座に出金',
  'aurora.comparison.traditional.step3.fee': '出金手数料が発生',
  'aurora.comparison.traditional.summary': '時間がかかり、手数料も高額',
  'aurora.comparison.aurora.title': 'Aurora Cardの方法',
  'aurora.comparison.aurora.step1': 'アプリに暗号資産を入金',
  'aurora.comparison.aurora.step1.fee': '入金手数料：1.3%のみ',
  'aurora.comparison.aurora.step2': 'すぐに決済可能',
  'aurora.comparison.aurora.step2.fee': 'クレジットカードとして即座に利用',
  'aurora.comparison.aurora.summary': 'シンプルで手数料も最小限',
  'aurora.comparison.table.title': 'デビットカードとの違い',
  'aurora.comparison.table.cardType': 'カードタイプ',
  'aurora.comparison.table.creditCard': 'クレジットカード',
  'aurora.comparison.table.debitCard': 'デビットカード',
  'aurora.comparison.table.postpaid': '後払い対応',
  'aurora.comparison.table.trust': '信託保護',
  'aurora.comparison.table.partial': '一部のみ',
  'aurora.comparison.table.merchants': '利用可能店舗',
  'aurora.comparison.table.allCredit': 'クレジット対応店すべて',
  'aurora.comparison.table.debitOnly': 'デビット対応店のみ',
  
  'aurora.trust.title': '信託機関との連携による高い安全性',
  'aurora.trust.subtitle': '顧客資産は法的に保護され、第三者からのアクセスを完全にブロック',
  'aurora.trust.features.title': '信託口座の特徴',
  'aurora.trust.features.confidentiality': '高い機密性',
  'aurora.trust.features.confidentiality.desc': '外部の当事者は顧客の信託資産情報にアクセス不可',
  'aurora.trust.features.risk': 'リスク緩和',
  'aurora.trust.features.risk.desc': '口座凍結に関連するリスクを大幅に軽減',
  'aurora.trust.features.privacy': 'プライバシー保護',
  'aurora.trust.features.privacy.desc': '第三者による情報閲覧を完全にブロック',
  'aurora.trust.bank.title': '一般的な銀行口座との比較',
  'aurora.trust.bank.lowConfidentiality': '機密性が低い',
  'aurora.trust.bank.lowConfidentiality.desc': '司法機関はいつでも情報の検閲が可能',
  'aurora.trust.bank.freezeRisk': '凍結リスク',
  'aurora.trust.bank.freezeRisk.desc': '特定の理由で口座を凍結する権利を有する',
  'aurora.trust.bank.limitedPrivacy': 'プライバシーが限定的',
  'aurora.trust.bank.limitedPrivacy.desc': '第三者がいつでも口座情報にアクセス可能',
  'aurora.trust.licenses.title': '保有ライセンス',
  
  'aurora.features.title': 'Aurora Cardの主な特徴',
  'aurora.features.subtitle': '暗号資産決済の新しいスタンダード',
  'aurora.features.mastercard.title': 'Mastercardブランド',
  'aurora.features.mastercard.desc': '世界中のMastercard加盟店で利用可能。オンライン・オフライン問わず、幅広い店舗で決済できます。',
  'aurora.features.unlimited.title': '入金・決済限度額無制限',
  'aurora.features.unlimited.desc': '入金額に制限なし。アプリ内のクレジット残高の範囲内で、決済も無制限に利用できます。',
  'aurora.features.japan.title': '日本国内で使用可能',
  'aurora.features.japan.desc': '日本国内のMastercard加盟店で問題なく利用できます。コンビニ、レストラン、オンラインショップなど。',
  'aurora.features.atm.title': 'ATM出金対応',
  'aurora.features.atm.desc': '1日最大5,000ドルまでATMから現金を引き出すことが可能。1日5回まで利用できます。',
  'aurora.features.postpaid.title': '後払い対応',
  'aurora.features.postpaid.desc': 'クレジットカードとしての機能を持つため、後払いにも対応。デビットカードにはない利便性を提供します。',
  'aurora.features.app.title': '専用アプリで簡単管理',
  'aurora.features.app.desc': '公式アプリから入金、残高確認、取引履歴の確認など、すべての操作を簡単に行えます。',
  'aurora.features.notice.title': '重要な注意事項',
  'aurora.features.notice.item1': 'ウォレット内に一度送金した資金は、他のウォレットに送金できません。',
  'aurora.features.notice.item2': 'カード発行には300ドル相当のUSDTが必要です。',
  'aurora.features.notice.item3': '税申告については、最寄りの税務署または税理士へご確認ください。',
  
  'aurora.fees.title': '手数料一覧',
  'aurora.fees.subtitle': '透明性の高い料金体系',
  'aurora.fees.item': '項目',
  'aurora.fees.fee': '料金',
  'aurora.fees.issuance': 'カード発行手数料',
  'aurora.fees.deposit': '入金手数料',
  'aurora.fees.annual': '年間会員費',
  'aurora.fees.annual.note': '(今後変更される場合あり)',
  'aurora.fees.atmWithdrawal': 'ATM引き出し手数料',
  'aurora.fees.atmWithdrawal.note': '(5%取引手数料 + 3%ATM引き出し手数料)',
  'aurora.fees.atmLimit': 'ATM出金限度額',
  'aurora.fees.atmLimit.note': '(1日のATM利用回数：5回まで)',
  'aurora.fees.depositLimit': '入金限度額',
  'aurora.fees.paymentLimit': '決済限度額',
  'aurora.fees.paymentLimit.note': '(アプリ内のクレジット残高)',
  'aurora.fees.transaction': '取引手数料',
  'aurora.fees.brand': 'ブランド',
  'aurora.fees.japanUse': '日本での使用',
  'aurora.fees.available': '利用可能',
  'aurora.fees.unlimited': '無制限',
  'aurora.fees.info': 'カード発行には300ドル相当のUSDTが必要になります。この費用は初回のみ発生します。',
  
  'aurora.cta.title': '暗号資産を、もっと自由に使おう',
  'aurora.cta.description': 'Aurora Cardは、暗号資産を保有する方にとって、特におすすめのクレジットカードです。面倒な現金化プロセスを省き、世界中どこでも暗号資産で決済できる自由を手に入れましょう。',
  'aurora.cta.button.apply': '今すぐカードを申し込む',
  'aurora.cta.button.details': '詳細を確認する',
  'aurora.cta.support.title': 'カスタマーサポート',
  'aurora.cta.support.telegram': 'Telegram',
  'aurora.cta.support.email': 'Email',
  'aurora.cta.disclaimer.title': '注意事項・免責事項',
  'aurora.cta.disclaimer.text': '本ページは情報提供のみを目的としております。ご利用時は各自のご判断にて行って下さいませ。また掲載している情報には細心の注意を払って掲載をしておりますが、正確性および完全性を保証するものではなく、生じた損失には責任を負えませんのでご理解を願います。※また予告なしに、掲載情報が変更になる場合も御座います。',

  // Lending
  'lending.hero.title': '暗号資産レンディング',
  'lending.hero.subtitle': '預けるだけで資産が増える',
  'lending.hero.currencies': '取扱通貨',
  'lending.hero.apy': '年利',
  'lending.hero.cta.start': '今すぐ始める',
  'lending.hero.cta.learn': '詳しく見る',

  'lending.recommended.title': '暗号資産レンディングはこんな方におすすめ',
  'lending.recommended.item1.title': '眠ってる通貨を有効活用したい方',
  'lending.recommended.item2.title': '株や投資信託では満足できない方',
  'lending.recommended.item3.title': '暗号資産で資産運用を始めたい方',
  'lending.recommended.item4.title': '暗号資産は気になるけど始め方がわからない方',

  'lending.safety.title': '初心者の方でも安心スタート',
  'lending.safety.zero1.title': '各種手数料ゼロで安心',
  'lending.safety.zero1.desc': '送金・返還手数料など余計なコストはゼロ！',
  'lending.safety.zero1.badge': 'すべて完全無料!!',
  'lending.safety.zero2.title': '自動運用で知識ゼロでも安心',
  'lending.safety.zero2.desc': '「選ぶ・預ける・待つ」だけであとはおまかせ自動運用！',
  'lending.safety.zero2.badge': '専門知識不要!!',
  'lending.safety.zero3.title': '増える満足・減らない安心',
  'lending.safety.zero3.desc': '預けた暗号資産はそのままあとは増えるのを待つだけ！',
  'lending.safety.zero3.badge': '枚数そのまま + α',
  'lending.safety.zeroRisk.title': 'ゼロリスク設計',
  'lending.safety.zeroRisk.desc': '考えうるあらゆるリスクに応えるゼロリスク設計',

  'lending.about.title': 'DP Crypt レンディングとは',
  'lending.about.desc1': 'DP Cryptは専門のプロトレーダーチームを編成し、暗号資産市場は勿論のこと、世界経済、株式、債券、為替などあらゆる市場を総合的に分析し、独自の運用方法を確立しております。',
  'lending.about.desc2': 'その為、業界最多の21種類の暗号資産レンディングを可能にしました。',
  'lending.about.desc3': 'レンディング初心者から他社で既にレンディングをやられてる方など全ての投資家に安心と安全の環境をご用意いたしました。',

  'lending.rates.badge': 'No.1',
  'lending.rates.title': '業界最高水準の利回り',
  'lending.rates.subtitle': '取扱い通貨数・年利ともに業界トップクラス',
  'lending.rates.currencies': '種類の暗号資産',
  'lending.rates.annual': '年',
  'lending.rates.desc': '経験豊富なプロトレーダーが24時間体制で運用。さらに、相場任せにせず徹底したデータ分析で設計された独自モデルを導入。だからこそ、高利回りでも安定したリターンを実現できるのです。',

  'lending.plans.title': '選べる2種類のレンディングコース',
  'lending.plans.subtitle': '安心のレンディングコースをご用意',
  'lending.plans.annual': '年',
  'lending.plans.recommended': 'おすすめ',
  'lending.plans.standard.period': '1ヶ月単位',
  'lending.plans.standard.name': 'スタンダード',
  'lending.plans.standard.desc': '預け入れから1ヶ月が経過した後はお客様のタイミングで暗号資産の返還が可能',
  'lending.plans.standard.feature1': '1ヶ月経過後いつでも返還可能',
  'lending.plans.standard.feature2': '柔軟な運用が可能',
  'lending.plans.extra.period': '1年単位',
  'lending.plans.extra.name': 'エクストラ',
  'lending.plans.extra.desc': '1年間は返還できませんが年13.2%で高リターン！1年経過後は自動更新となり再度1年契約となります',
  'lending.plans.extra.feature1': '業界最高水準の年利13.2%',
  'lending.plans.extra.feature2': '1年後自動更新で長期運用に最適',

  'lending.howItWorks.title': '暗号資産レンディングとは',
  'lending.howItWorks.step1.title': '1. 預入',
  'lending.howItWorks.step1.desc': 'USDTを預けてレンディング開始',
  'lending.howItWorks.step2.title': '2. 運用',
  'lending.howItWorks.step2.desc': 'プロが安全に資産を運用',
  'lending.howItWorks.step3.title': '3. 受取',
  'lending.howItWorks.step3.desc': '毎日利息を受け取り資産が増加',
  'lending.howItWorks.badge': '24時間365日自動運用',
  'lending.howItWorks.desc': 'お客様が保有されている暗号資産を、一定期間、弊社にお預けいただくことで、暗号資産の枚数そのまま+プラスαでお戻しする仕組みです。弊社ではお預かりした暗号資産は、弊社の専門運用チームが独自のノウハウをもとにさまざまな市場で分散運用。その過程で得られたキャピタルゲイン(値上がり益)を得てお客様へ還元いたします。',
  'lending.howItWorks.advantage.title': 'Wチャンス',
  'lending.howItWorks.advantage.desc': '枚数が増える！さらに資産価値が上がればWチャンス！暗号資産は、保有枚数そのものを増やすことができるうえに、価格が上昇することで資産価値も高まります。市場は日々変動が激しく、通常の取引にはリスクが伴いますが、レンディングを活用すれば価格変動の影響を受けず、安定的に保有資産を増やしていくことが可能です。',

  'lending.comparison.badge': '他社比較',
  'lending.comparison.title': '業界最高水準のサービス',
  'lending.comparison.table.feature': '項目',
  'lending.comparison.table.mycoin': 'DP Lending',
  'lending.comparison.table.others': '他社サービス',
  'lending.comparison.table.rate': '年利',
  'lending.comparison.table.fee': '手数料',
  'lending.comparison.table.free': '無料',
  'lending.comparison.table.charged': '有料',
  'lending.comparison.table.minAmount': '最低貸出額',
  'lending.comparison.table.noMin': '制限なし',
  'lending.comparison.table.hasMin': '制限あり',
  'lending.comparison.table.lockPeriod': 'ロック期間',
  'lending.comparison.table.noLock': 'なし',
  'lending.comparison.table.hasLock': 'あり',
  'lending.comparison.table.currencies': '対応通貨',
  'lending.comparison.table.types': '種類',
  'lending.comparison.table.support': 'サポート',
  'lending.comparison.table.limited': '限定的',
  'lending.comparison.table.withdrawal': '引き出し',
  'lending.comparison.table.anytime': 'いつでも可能',
  'lending.comparison.table.restricted': '制限あり',
  'lending.comparison.terms.title': '用語集',
  'lending.comparison.terms.period.title': '預入期間',
  'lending.comparison.terms.period.desc': '暗号資産をレンディングサービスに預ける期間のこと。この間は、引き出しや売却ができません。一般的に、預ける期間が長いほど年利が高くなる傾向があります。',
  'lending.comparison.terms.reinvest.title': '自動再投資',
  'lending.comparison.terms.reinvest.desc': '得られた利息をそのまま自動で再投資する仕組み。運用益が利息を生み、それがさらに再投資されることで資産が効率よく増え続ける複利効果が期待できます。',
  'lending.comparison.terms.fees.title': '手数料',
  'lending.comparison.terms.fees.return': '①返還手数料',
  'lending.comparison.terms.fees.returnDesc': '運用期間終了後に暗号資産を返却する際にかかる手数料。',
  'lending.comparison.terms.fees.transfer': '②送金手数料',
  'lending.comparison.terms.fees.transferDesc': '暗号資産を送るときにかかるブロックチェーンの利用料。',
  'lending.comparison.terms.fees.noFee': '※弊社なら手数料は一切かかりません！',

  'lending.security.title': '「見れる」安心！「守られる」信頼！',
  'lending.security.subtitle': 'お客様ごとの専用管理サイトをご用意',
  'lending.security.desc': '資産運用を始める上で大切なのは「どれだけ安心して預けられるか」お客様ごとの専用管理サイトをご用意。預け入れ状況・利回り・付与履歴などの情報をリアルタイムで確認可能',
  'lending.security.bankLevel': '銀行レベルのセキュリティ',
  'lending.security.feature1': '通信の暗号化（SSL/TLS対応）',
  'lending.security.feature2': '二段階認証（2FA）',
  'lending.security.feature3': '操作がないと自動ログアウト',
  'lending.security.feature4': 'サーバー監視・不正アクセス検知',

  'lending.steps.title': '簡単3STEPで簡単登録',
  'lending.steps.subtitle': 'STEP簡単登録',
  'lending.steps.step1.title': '会員情報登録',
  'lending.steps.step1.desc': 'お名前、メールアドレス、任意のパスワードを登録。登録後に入力したメールアドレスに認証コードが届くので、認証を行ってください。',
  'lending.steps.step2.title': '身分証のアップロード',
  'lending.steps.step2.desc': 'マイナンバーカード / 保険証 / 運転免許証のいずれか1枚を撮影しアップロード。',
  'lending.steps.step3.title': 'レンディング開始',
  'lending.steps.step3.desc': 'プラン・銘柄や預け数量を設定して暗号資産を送付し、レンディング開始！',

  'lending.faq.title': 'よくあるご質問',
  'lending.faq.q1.question': '利息の計算式を教えてください',
  'lending.faq.q1.answer': '利息 = (預入れ枚数 × 預入れ期間(日) × 年利) ÷ 365\n\n例:スタンダードコースの場合(年利10%)\n(20枚×200日×10%) ÷ 365 = 1.0958\n\n利息は日割りで計算・付与されるため、資産は毎日少しずつ確実に増えていきます。',
  'lending.faq.q2.question': '最短貸出期間について教えてください',
  'lending.faq.q2.answer': '最短貸出期間は1ヶ月(30日間)です。暗号資産を貸し出す場合、貸出実行日(当社が受取処理を完了した翌日)から30日間は返還はできません。',
  'lending.faq.q3.question': '他業者と比べて、高い利息を実現できるのはなぜですか？',
  'lending.faq.q3.answer': 'お客様がお預けいただいた暗号資産は、当社の専門運用チームが市場動向を的確に捉え、複数のマーケットで分散的に運用しています。運用プロセスでは、独自の分析・戦略を駆使し、キャピタルゲイン(値上がり益)などの収益機会を積極的に追求。その成果をお客様へ還元することで、競合他社よりも高い利息を実現しています。',
  'lending.faq.q4.question': '暗号資産の知識がないので日本円で振込みはできますか？',
  'lending.faq.q4.answer': '申し訳ございませんが、当社では暗号資産のみのお取り扱いとなっております。日本円での直接のお振込みには対応しておりません。お客様が保有する暗号資産をお預けいただくかたちでのご利用をお願いしております。',
  'lending.faq.q5.question': '返還手数料などかかりますか？',
  'lending.faq.q5.answer': '返還手数料・送金手数料・解除手数料など、当社では一切手数料をいただいておりませんのでご安心ください。',

  'lending.cta.title': '全部ほしいが預けるだけで叶う！',
  'lending.cta.description': '暗号資産を預けるだけで、安定した利回りを実現。専門知識不要で、誰でも簡単に始められます。',
  'lending.cta.button': '今すぐ始める',
  'lending.cta.disclaimer.title': '注意事項・免責事項',
  'lending.cta.disclaimer.text': '本ページは情報提供のみを目的としております。ご利用時は各自のご判断にて行って下さいませ。また掲載している情報には細心の注意を払って掲載をしておりますが、正確性および完全性を保証するものではなく、生じた損失には責任を負えませんのでご理解を願います。※また予告なしに、掲載情報が変更になる場合も御座います。',
};

export default common;
